var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.216,
    height: 18.216,
    viewBox: "0 0 18.216 18.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 512",
    d: "M9.108 0a9.108 9.108 0 1 0 9.108 9.108A9.108 9.108 0 0 0 9.108 0zm.846 12.621H8.132V7.937h1.822zm-.911-5.465a.911.911 0 1 1 .911-.911.911.911 0 0 1-.911.911z",
    style: {
      fill: "#ff8d2a"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeInfo);
export default __webpack_public_path__ + "static/media/orange-info.5aea5eb415246055a787f70408d8e757.svg";
export { ForwardRef as ReactComponent };